// extracted by mini-css-extract-plugin
module.exports = {"header":"Customer_header__2qPQf"};